import { render, staticRenderFns } from "./PatternContentFooter.vue?vue&type=template&id=371c5f2e&"
import script from "./PatternContentFooter.vue?vue&type=script&lang=js&"
export * from "./PatternContentFooter.vue?vue&type=script&lang=js&"
import style0 from "./PatternContentFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports